type Props = {
  visible: boolean;
  label?: string;
};

export default function LoadingOverlay({ visible, label = "Загрузка данных..." }: Props) {
  if (!visible) return null;

  return (
    <div className="absolute inset-0 z-10 grid place-items-center rounded-3xl bg-white/70 backdrop-blur-sm">
      <div className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white px-6 py-4 text-base font-semibold text-slate-700 shadow-md">
        <span className="h-7 w-7 animate-spin rounded-full border-[3px] border-indigo-200 border-t-indigo-600" />
        {label}
      </div>
    </div>
  );
}
